<div class="container">
  <div class="text-center">
    <h1 class="fs-3 fw-bold" style="color: #8e0e00">Version Status</h1>
  </div>

  <div class="row">
    <!-- Buttons -->
    <div
      class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2"
    >
      <button
        class="btn btn-success"
        ngbTooltip="Export to excel"
        (click)="exportToExcel()"
      >
        <span><i class="bi bi-box-arrow-up me-2"></i></span> Export
      </button>
      <!-- <button class="btn btn-success" ngbTooltip="Print">
                <span><i class="bi bi-printer me-2"></i></span>Print
            </button> -->
      <button
        class="btn btn-success"
        ngbTooltip="Clear filter"
        (click)="resetFilter()"
      >
        <span> <i class="bi bi-x-circle me-2"></i></span>Clear
      </button>
    </div>
    <!-- Search -->
    <div class="col-lg-3 col-md-3 mt-3 col-sm-12">
      <input
        type="text"
        class="form-control"
        placeholder="Search City"
        (input)="onSearch($event)"
      />
    </div>
  </div>
  <div class="card shadow-lg p-3 mt-3">
    <div class="table-responsive">
      <!-- Table -->
      <table class="table table-striped table-bordered text-center">
        <thead>
          <tr>
            <th
              *ngFor="let row of tableHeaders; let i = index"
              class="text-center"
            >
              {{ row }}
              <i
                *ngIf="['User', 'City', 'Zone', 'Platform Type'].includes(row)"
                class="bi bi-funnel ms-2"
                (click)="toggleDropdown(row)"
              ></i>
              <!-- Dropdown for filters -->
              <div *ngIf="activeDropdown === row" class="dropdown-menu show">
                <div class="px-3 py-2">
                  <div
                    class="filter-options"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <div
                      *ngFor="let option of availableFilters[row]"
                      class="dropdown-item"
                      (click)="applyFilter($event, row)"
                    >
                      {{ option }}
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData">
            <td class="text-center">{{ row.userType }}</td>
            <td>
              {{
                row.userType === "Individual Requester"
                  ? row.username
                  : row.companyName
              }}
            </td>
            <td class="text-center">{{ row.mobileNumber }}</td>
            <td class="text-center">{{ row.city }}</td>
            <td class="text-center">{{ row.zone }}</td>
            <td class="text-center">{{ row.userPlatform }}</td>
            <td class="text-center">{{ row.platformVersion }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="versionList?.length > 0"
          [maxSize]="3"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="versionList?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>

      <!-- Entries Message Aligned to the End -->
      <div *ngIf="versionList?.length > 0" class="text-muted mb-3">
        <strong
          >Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > versionList?.length
              ? versionList?.length
              : page * pageSize
          }}
          of {{ versionList?.length }} entries</strong
        >
      </div>
    </div>
  </div>
</div>
